export const CODE_NO_PROJECT_ACCESS_OLD = 'Code: 4404'
export const CODE_NO_PROJECT_ACCESS_NEW = 'You do not have permission'
